import { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";

export enum OperationButtonType {
  Normal,
  Danger,
  Disabled,
}
export enum Operation {
  Download = "Download",
  Delete = "Delete",
  DownloadBill = "DownloadBill",
  ConfirmBill = "ConfirmBill",
  ComplaintProgress = "ComplaintProgress",
}
export function OperationButton({
  text,
  operation = Operation.Download,
  type = OperationButtonType.Normal,
  gap = 10,
  onClick,
  disabled,
  width,
  style,
}: {
  text?: string;
  type?: OperationButtonType;
  operation?: string | Operation;
  gap?: number;
  onClick?: () => void;
  disabled?: boolean;
  width?: string;
  style?: CSSProperties;
}) {
  // shit
  const { t } = useTranslation("operation");

  return (
    <OperationWrapper
      type={disabled ? OperationButtonType.Disabled : type}
      gap={gap}
      width={width}
      data-type={disabled ? "" : operation}
      style={style}
      onClick={() => (disabled ? null : onClick?.())}
    >
      {text ?? t(`operation_${operation}`)}
    </OperationWrapper>
  );
}

const OperationWrapper = styled.span<{
  type?: OperationButtonType;
  gap?: number;
  width?: string;
  style?: CSSProperties;
}>`
  cursor: pointer;
  ${(p) =>
    p.width &&
    css`
      width: ${p.width};
    `}
  color: ${({ type }) =>
    ({
      [OperationButtonType.Danger]: "#FF4444",
      [OperationButtonType.Normal]: "var(--main-color)",
      [OperationButtonType.Disabled]: "rgba(255, 255, 255, 0.35)",
    }[type ?? OperationButtonType.Normal])};

  & + & {
    margin-left: ${({ gap }) => (gap ? `${gap}px` : 0)};
  }
`;
